import React, { useRef, useState } from "react";
import {
  Upload,
  FileText,
  X,
  User,
  Phone,
  Wallet,
  Building2,
  ArrowLeft,
  ArrowRight,
} from "lucide-react";
import AppButton from "../../../../components/common/appButton/AppButton";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import axios from "axios";
import { BASE_URL } from "../../../../config/config";

const OwnerDetailsPending = ({
  onNext,
  onBack,
}) => {
  const fileInputRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate()
  const [loading,setIsLoading] = useState(false)
  const token = location.state?.token;
  const email = location.state?.email;
  const role = location.state?.role;
  const [data, setData] = useState({
        first_name: "",
        last_name: "",
        phone_number: "",
        wallet_address : "",
        preferredLocations: "",
        emirates_id: null,
        budget :"",
        moveInTimeline :"",
        agencyName: "",
        licenseNumber: "",
      });
    
      
      const updateData = (data) => {
        setData((prev) => ({
          ...prev,
          ...data,
        }));
      };

const handleSubmit = async () => {
  if (!token) {
    message.error("You don't have access");
    navigate("/login");
    return;
  }

  const requiredFields = [
    {
      value: data?.first_name,
      message: "First Name is required",
    },
    {
      value: data?.last_name,
      message: "Last Name is required",
    },
    // {
    //   value: data?.phone_number,
    //   message: "Phone Number is required",
    // },
    {
      value: data?.emirates_id,
      message: "Emirates ID is required",
    },
  ];

  const missingField = requiredFields.find(
    (field) =>
      field.value === null ||
      field.value === undefined ||
      (typeof field.value === "string" && !field.value.trim())
  );

  if (missingField) {
    message.error(missingField.message);
    return;
  }
setIsLoading(true)
  try {
    // Use FormData because Emirates ID is a file
    const formData = new FormData();

    formData.append("first_name", data?.first_name.trim());
    formData.append("last_name", data?.last_name.trim());
    formData.append("phone_number", data?.phone_number.trim());
    // formData.append("wallet_address", data?.wallet_address.trim());
    // formData.append("agencyName", data?.agencyName.trim());
    // formData.append("licenseNumber", data?.licenseNumber.trim());
    // Emirates ID file
    if (data?.emirates_id instanceof File) {
      formData.append("emirates_id", data.emirates_id);
    }

    // Debug FormData
    for (const [key, value] of formData.entries()) {
      console.log(
        key,
        value instanceof File
          ? {
              name: value.name,
              type: value.type,
              size: value.size,
            }
          : value
      );
    }

    const response = await axios.post(
      `${BASE_URL}/owner/complete-registration`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    message.success("Registration completed successfully");
    console.log("Registration response:", response);
            localStorage.setItem("rwatoken", response?.data?.access_token);
            localStorage.setItem("userRole", "owner");
            window.location.replace("/agent/home");


    // If required:
    // onNext?.();
  } catch (error) {
    console.log("Complete registration error:", error);

    message.error(error?.response?.data?.detail[0]?.msg || error?.response?.data?.detail ||
        "Something went wrong. Please try again."
    );
  }finally{
    setIsLoading(false)
  }
};

  const handlePhoneChange = (e) => {
    let value = e.target.value;

    let digits = value.replace(/\D/g, "");

    if (digits.startsWith("971")) {
      digits = digits.slice(3);
    }

    digits = digits.slice(0, 9);

    let formatted = "+971";

    if (digits.length > 0) {
      formatted += ` ${digits.slice(0, 2)}`;
    }

    if (digits.length > 2) {
      formatted += ` ${digits.slice(2, 5)}`;
    }

    if (digits.length > 5) {
      formatted += ` ${digits.slice(5, 9)}`;
    }

    updateData({
      phone_number: formatted,
    });
  };


  const handleEmiratesIdChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    updateData({
      emirates_id: file,
    });
  };

  const removeEmiratesId = () => {
    updateData({
      emirates_id: null,
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <main className="min-h-screen w-full overflow-hidden bg-[#fdfbf5] text-[#1f2318]">
      <section className="mx-auto flex min-h-screen w-full overflow-hidden bg-white lg:grid lg:grid-cols-[55.5%_44.5%]">

        {/* LEFT — SAME TERRA VISUAL LANGUAGE AS LOGIN */}
        <div className="relative hidden min-h-screen overflow-hidden lg:block">
          <img
            src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85"
            alt="Modern UAE real estate property"
            className="absolute inset-0 h-full w-full object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#172114]/20 via-transparent to-transparent" />

          <div className="absolute left-8 top-8 z-10 flex items-center gap-2 sm:left-10 sm:top-9">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/35 bg-white/15 text-white backdrop-blur-md">
              <Building2 size={15} strokeWidth={2.2} />
            </div>
            <span className="text-[14px] font-semibold tracking-[-0.01em] text-white">
              
            </span>
          </div>

          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md sm:right-10 sm:top-9">
            UAE Real Estate
          </div>

          <div className="absolute bottom-7 left-8 right-8 z-10 sm:bottom-9 sm:left-10 sm:right-10 lg:bottom-10">
            <div className="mb-2 text-[9px] font-bold uppercase tracking-[0.17em] text-[#dce8cf] sm:text-[10px]">
              CREATE YOUR REAL ESTATE ACCOUNT
            </div>

            <h1 className="max-w-[650px] font-['Playfair_Display'] text-[38px] font-normal leading-[1.03]  text-white sm:text-[46px] lg:text-[48px]">
              Build your
              <br />
              <span className="italic font-medium tracking-[0.025em] text-[40px] text-[#ccc]">
                real estate journey.
              </span>
            </h1>

            <p className="mt-3 max-w-[470px] text-[11px] leading-[1.6] text-white/75 sm:text-[12px]">
              Create your account and get access to your UAE real estate
              experience from one simple Platform.
            </p>

            <div className="mt-6 grid max-w-[500px] grid-cols-[1fr_auto_1fr_auto_1fr] items-center rounded-[12px] border border-white/15 bg-[#171e23]/60 px-3 py-2.5 backdrop-blur-xl sm:px-4 sm:py-3">
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">AED</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">UAE currency</span>
              </div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">UAE</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Property market</span>
              </div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">Digital</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Account access</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — SIGNUP CONTENT */}
        <div className="relative flex min-h-screen w-full items-center justify-center bg-white px-6 py-12 sm:px-10 lg:px-12 xl:px-16">
          {/* Back button stays at the top-left of the right panel */}
          <button
            type="button"
            onClick={()=>navigate("/login")}
            aria-label="Go back"
            className="absolute left-6 top-6 inline-flex items-center gap-2 rounded-full border border-[#e2e7de] bg-white px-3.5 py-2 text-[11px] font-semibold text-[#6f7468] shadow-[0_5px_18px_rgba(55,92,32,0.06)] transition hover:-translate-y-px hover:border-[#cddcbd] hover:bg-[#f7f9f4] hover:text-[#4c7a2e] sm:left-10 sm:top-8 lg:left-12"
          >
            <ArrowLeft size={14} />
            Back
          </button>

          <div className="w-full max-w-[500px] pt-10 sm:pt-7 mt-10">
            <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.14em] text-[#6a7847]">
        Required information
      </div>

      <h1 className="font-['Playfair_Display'] text-[30px] leading-[1.08] tracking-[-0.035em] text-[#1f2318] sm:text-[34px]">
        Complete your{" "}profile
      </h1>

      <p className="mt-2 text-[11px] leading-5 text-[#92968e]">
        Tell us a little more about you to complete your
        Property Owner registration.
      </p>

      <div className="mt-6 space-y-5">

    
        <div>
          <div className="mb-3 flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded-lg bg-[#edf3e8] text-[#4c7a2e]">
              <User size={12} />
            </div>

            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#596257]">
              Personal Information
            </p>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

            {/* First Name */}

            <div>
              <label className="mb-2 block text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
                First Name
                <span className="ml-1 text-[#4c7a2e]">
                  *
                </span>
              </label>

              <input
                type="text"
                value={data?.first_name || ""}
                onChange={(e) =>
                  updateData({
                    first_name: e.target.value,
                  })
                }
                placeholder="Enter first name"
                className="
                  h-[45px]
                  w-full
                  rounded-[10px]
                  border
                  border-[#e1e5dd]
                  bg-white
                  px-3.5
                  text-[11px]
                  text-[#1f2318]
                  outline-none
                  transition
                  placeholder:text-[#a5aaa3]
                  focus:border-[#7da458]
                  focus:ring-4
                  focus:ring-[#4c7a2e]/[0.07]
                "
              />
            </div>

            {/* Last Name */}

            <div>
              <label className="mb-2 block text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
                Last Name
                <span className="ml-1 text-[#4c7a2e]">
                  *
                </span>
              </label>

              <input
                type="text"
                value={data?.last_name || ""}
                onChange={(e) =>
                  updateData({
                    last_name: e.target.value,
                  })
                }
                placeholder="Enter last name"
                className="
                  h-[45px]
                  w-full
                  rounded-[10px]
                  border
                  border-[#e1e5dd]
                  bg-white
                  px-3.5
                  text-[11px]
                  text-[#1f2318]
                  outline-none
                  transition
                  placeholder:text-[#a5aaa3]
                  focus:border-[#7da458]
                  focus:ring-4
                  focus:ring-[#4c7a2e]/[0.07]
                "
              />
            </div>

          </div>
        </div>
        <div>
          <label className="mb-2 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
            <Phone size={11} className="text-[#6a7847]" />
            Phone Number
            {/* <span className="text-[#4c7a2e]">*</span> */}
          </label>

          <input
            type="tel"
            value={data?.phone_number || ""}
            onChange={handlePhoneChange}
            placeholder="+971 50 000 0000"
            className="
              h-[45px]
              w-full
              rounded-[10px]
              border
              border-[#e1e5dd]
              bg-white
              px-3.5
              text-[11px]
              text-[#1f2318]
              outline-none
              transition
              placeholder:text-[#a5aaa3]
              focus:border-[#7da458]
              focus:ring-4
              focus:ring-[#4c7a2e]/[0.07]
            "
          />
        </div>

       


        <div>

          <label className="mb-2 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
            <FileText
              size={11}
              className="text-[#6a7847]"
            />

            Emirates ID

            <span className="text-[#4c7a2e]">*</span>
          </label>

          {!data?.emirates_id ? (
            <button
              type="button"
              onClick={() =>
                fileInputRef.current?.click()
              }
              className="
                flex
                min-h-[92px]
                w-full
                flex-col
                items-center
                justify-center
                rounded-[12px]
                border
                border-dashed
                border-[#cfd9c8]
                bg-[#fafcf8]
                px-4
                text-center
                transition
                hover:border-[#7da458]
                hover:bg-[#f6faf2]
              "
            >
              <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-lg bg-[#eaf2e3] text-[#4c7a2e]">
                <Upload size={14} />
              </div>

              <p className="text-[10px] font-semibold text-[#596257]">
                Upload Emirates ID
              </p>

              <p className="mt-1 text-[8px] text-[#9a9f96]">
                PDF, JPG or PNG · Max 10MB
              </p>
            </button>
          ) : (
            <div className="flex items-center justify-between rounded-[12px] border border-[#dce7d5] bg-[#f7faf4] px-3.5 py-3">

              <div className="flex min-w-0 items-center gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#e6f0df] text-[#4c7a2e]">
                  <FileText size={15} />
                </div>

                <div className="min-w-0">
                  <p className="truncate text-[10px] font-semibold text-[#37452f]">
                    {data.emirates_id.name}
                  </p>

                  <p className="mt-0.5 text-[8px] text-[#92968e]">
                    {(
                      data.emirates_id.size /
                      (1024 * 1024)
                    ).toFixed(2)}{" "}
                    MB
                  </p>
                </div>

              </div>

              <button
                type="button"
                onClick={removeEmiratesId}
                className="ml-3 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-[#8c9388] shadow-sm transition hover:text-[#b45850]"
              >
                <X size={13} />
              </button>

            </div>
          )}

          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            className="hidden"
            onChange={handleEmiratesIdChange}
          />

        </div>

         {/* <div>
          <label className="mb-2 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
            <Wallet size={11} className="text-[#6a7847]" />
            Company Name / Agency Name
          </label>

          <input
            type="text"
            value={data?.agencyName || ""}
            onChange={(e) =>
              updateData({
                agencyName: e.target.value,
              })
            }
            placeholder="Enter Company / Agent Name"
            className="
              h-[45px]
              w-full
              rounded-[10px]
              border
              border-[#e1e5dd]
              bg-white
              px-3.5
              text-[11px]
              text-[#1f2318]
              outline-none
              transition
              placeholder:text-[#a5aaa3]
              focus:border-[#7da458]
              focus:ring-4
              focus:ring-[#4c7a2e]/[0.07]
            "
          />
        </div> */}

{/* <div>
          <label className="mb-2 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
            <Wallet size={11} className="text-[#6a7847]" />
            License Number
          </label>

          <input
            type="text"
            value={data?.licenseNumber || ""}
            onChange={(e) =>
              updateData({
                licenseNumber: e.target.value,
              })
            }
            placeholder="eg: 12344433"
            className="
              h-[45px]
              w-full
              rounded-[10px]
              border
              border-[#e1e5dd]
              bg-white
              px-3.5
              text-[11px]
              text-[#1f2318]
              outline-none
              transition
              placeholder:text-[#a5aaa3]
              focus:border-[#7da458]
              focus:ring-4
              focus:ring-[#4c7a2e]/[0.07]
            "
          />
        </div> */}
        {/* =====================================================
            INVESTMENT PREFERENCES
        ===================================================== */}

        {/* <div>

          <div className="mb-3">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#596257]">
              Investment Preferences
            </p>

            <p className="mt-1 text-[9px] text-[#9a9f96]">
              Help us understand what you're looking for.
            </p>
          </div>

          <div className="space-y-4">


            <SelectField
              label="Budget Range"
              value={data?.budget || ""}
              placeholder="Select your budget"
              options={[
                "Under $500K",
                "$500K - $1M",
                "$1M - $2M",
                "$2M+",
              ]}
              onChange={(value) =>
                updateData({
                  budget: value,
                })
              }
            />


            <SelectField
              label="Move-in Timeline"
              value={data?.moveInTimeline || ""}
              placeholder="When are you planning to move?"
              options={[
                "Immediately",
                "Within 3 months",
                "3 - 6 months",
                "6+ months",
              ]}
              onChange={(value) =>
                updateData({
                  moveInTimeline: value,
                })
              }
            />


            <div>
              <label className="mb-2 block text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
                Preferred Locations
              </label>

              <input
                value={data?.preferredLocations || ""}
                onChange={(e) =>
                  updateData({
                    preferredLocations:
                      e.target.value,
                  })
                }
                placeholder="e.g. Dubai Marina, Downtown Dubai"
                className="
                  h-[45px]
                  w-full
                  rounded-[10px]
                  border
                  border-[#e1e5dd]
                  bg-white
                  px-3.5
                  text-[11px]
                  text-[#1f2318]
                  outline-none
                  transition
                  placeholder:text-[#a5aaa3]
                  focus:border-[#7da458]
                  focus:ring-4
                  focus:ring-[#4c7a2e]/[0.07]
                "
              />
            </div>

          </div>
        </div> */}



      </div>
      <div className="mt-6 flex gap-3">

    

        <AppButton onClick={handleSubmit} loading={loading}>
          Submit →
        </AppButton>

        </div>
          </div>
        </div>
  
      </section>
    </main>
  );
};




const SelectField = ({
  label,
  value,
  placeholder,
  options,
  onChange,
}) => {
  return (
    <div>

      <label className="mb-2 block text-[9px] font-semibold uppercase tracking-[0.1em] text-[#77818c]">
        {label}
      </label>
       {label !== "Budget Range" && (
    <span className="ml-1 text-[#4c7a2e]">*</span>
  )}

      <select
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
        className="
          h-[45px]
          w-full
          rounded-[10px]
          border
          border-[#e1e5dd]
          bg-white
          px-3.5
          text-[11px]
          text-[#1f2318]
          outline-none
          transition
          focus:border-[#7da458]
          focus:ring-4
          focus:ring-[#4c7a2e]/[0.07]
        "
      >
        <option value="">
          {placeholder}
        </option>

        {options.map((option) => (
          <option
            key={option}
            value={option}
          >
            {option}
          </option>
        ))}
      </select>

    </div>
  );
};

export default OwnerDetailsPending;


